import React from "react";
import { Empty, Masonry, Tabs, Typography } from "antd";
import { matchesSearch } from "../utils";
import { STICKY_TABS_OFFSET } from "../constants";
import ProductCard from "./ProductCard";

const { Text } = Typography;

export default function CategoryTabs({ products, categories, searchTerm, onSelectProduct }) {
  return (
    <Tabs
      centered
      defaultActiveKey={categories[0]?.id}
      tabBarStyle={{
        position: "sticky",
        top: STICKY_TABS_OFFSET,
        zIndex: 100,
        background: "var(--ant-layout-body-background)",
      }}
      items={categories.map((cat) => {
        const categoryProducts = products.filter(
          (p) => p.category === cat.category && matchesSearch(p, searchTerm)
        );

        const masonryItems = categoryProducts.map((product) => ({
          key: product.id,
          data: product,
        }));

        return {
          key: cat.id,
          label: cat.category,
          children:
            categoryProducts.length > 0 ? (
              <Masonry
                columns={{ xs: 2, sm: 2, md: 3, lg: 4, xl: 5 }}
                gutter={{ xs: 8, sm: 12, md: 16 }}
                items={masonryItems}
                itemRender={({ data: product }) => (
                  <ProductCard product={product} onSelect={onSelectProduct} />
                )}
              />
            ) : (
              <Empty
                style={{ padding: "48px 0" }}
                description={
                  <Text type="secondary">
                    {searchTerm
                      ? "Ningún producto coincide con tu búsqueda"
                      : "No hay productos en esta categoría"}
                  </Text>
                }
              />
            ),
        };
      })}
    />
  );
}
